/* eslint-disable @typescript-eslint/no-var-requires */
import _ from "lodash";

const config = require("@/config");
const ENV = process.env.NODE_ENV;
const { BASE_URL } = ENV ? _.get(config, ENV) : "";

export const BASEURL: string = BASE_URL == "/" ? BASE_URL : BASE_URL + "/";
